module.exports = __webpack_public_path__ + "static/media/m-biome.67a08605.png";